import styled from 'styled-components'
import { center, vFlex } from '../../../../../../../Styles/style-helpers'

export const VideoRecordModalEl = styled.div`
  ${center}
  ${vFlex}
  max-width: 75%;
  height: 80vh;
  padding: 2em 1em;
  background: white;
  border-radius: 1em;
  box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.25);
  justify-content: flex-start;
  overflow: auto;

  h5 {
    width: 100%;
    margin-bottom: 0.8em;
  }

  .video-container {
    width: 100%;
  }
`
